import $ from 'jquery'

function actionsTabbedContent() {
  
  if ($('.tabbed-content .tabbed-nav').length > 0) {

    // Click
    $('.tabbed-content .tabbed-nav').click(function(e){
      toggleTabbedNav($(this));
    });

    // Init
  
    $('.tabbed-content .tabbed-nav:first-child').each(function(){
      toggleTabbedNav($(this));
    });

  }

    function toggleTabbedNav(thisLink){

      var nav_items = $(thisLink).closest('.tabbed-content').find('.tabbed-nav[data-index]');
      var content_items = $(thisLink).closest('.tabbed-content').find('.tabbed-item[data-index]');
      var thisIndex = $(thisLink).attr('data-index');

      console.log( thisIndex );

      // Nav Items
      nav_items.each(function () {
        if ($(this).attr('data-index') == thisIndex) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });

      // Content Items
      content_items.each(function () {
        if ($(this).attr('data-index') == thisIndex) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });

    }

}

export default actionsTabbedContent
